const getCurrentStepType = "INIT";
const hasSpeechType = "HAS_SPEECH";
const speechBeginningType = "SPEECH_BEGINNING";
const speechEndingType = "SPEECH_ENDING";
const changeStepType = "CHANGE_STEP";
const changeTabType = "CHANGE_TAB";
const setErrorMessageType = "SET_ERROR_MESSAGE";
const setDevModeType = "SET_DEV_MODE";
const setTrainingModeType = "SET_TRAINING_MODE";
const changeUnlockedType = "CHANGE_UNLOCKED";
const loginRequiredType = "LOGIN_REQUIRED";

export const badRequest = -1;
export const tryLater = -2;
export const done = -3;

var arrSpeech;

const currentState = {
    // props not used locally
    allowDevMode: false,
    allowTrainingMode: false,
    errorMessage: null,
    loginRequired: false,
    hasSpeech: false,
    speechPlayedCount: 0,
    speechSupported: ("speechSynthesis" in window),
    trainingMode: false,
    unlocked: false,
    // props used locally
    currentTabId: 1,
    devMode: false,
    key: null,
    speechPlayed: false,
    speechPlaying: false,
    step: 0,
    volume: 0.5
};

export const actionCreators = {
    getCurrentStep: key => async (dispatch, getState) => {
        if (currentState.step > 0) {
            return;
        }

        currentState.key = key;

        (async () => {
            await fetch(`api/AssessmentData/GetCurrentStep/${key}`, {
                    method: "GET",
                    headers: {
                        'Accept': "application/json",
                        'Content-Type': "application/json"
                    }
                })
                .then(function (response) {
                    if (response.status !== 200) {
                        dispatch({ type: setErrorMessageType, errorMessage: response.status.toString() });
                        return null;
                    }
                    return response.json();
                })
                .then(function (json) {
                    if (json !== undefined && json !== null) {
                        cancelSpeechForChangeStep();
                        currentState.devMode = json.allowDevMode;
                        currentState.step = json.step;
                        dispatch({ type: getCurrentStepType, data: json });
                    }
                })
                .catch(err => {
                    dispatch({ type: setErrorMessageType, errorMessage: err.message });
                });
        })();
    },
    jumpTo: (step) => async (dispatch, getState) => {
        const body = JSON.stringify({ key: currentState.key, step: step });

        (async () => {
            await fetch(`api/AssessmentData/JumpTo`, {
                    method: "POST",
                    headers: {
                        'Accept': "application/json",
                        'Content-Type': "application/json"
                    },
                    body: body
                })
                .then(function (response) {
                    if (response.status !== 200) {
                        dispatch({ type: setErrorMessageType, errorMessage: response.status.toString() });
                        return null;
                    }
                    if (response.url.includes("Security/Login")) {
                        dispatch({ type: loginRequiredType });
                        return null;
                    }
                    return response.json();
                })
                .then(function (json) {
                    if (json !== undefined && json !== null) {
                        cancelSpeechForChangeStep();
                        currentState.step = json.step;
                        dispatch({ type: changeStepType });
                    }
                })
                .catch(err => {
                    dispatch({ type: setErrorMessageType, errorMessage: err.message });
                });
        })();
    },
    next: (data) => async (dispatch, getState) => {
        const body = JSON.stringify({ key: currentState.key, step: currentState.step, data: JSON.stringify(data)});

        (async () => {
            await fetch(`api/AssessmentData/Next`, {
                    method: "POST",
                    headers: {
                        'Accept': "application/json",
                        'Content-Type': "application/json"
                    },
                    body: body
                })
                .then(function (response) {
                    if (response.status !== 200) {
                        dispatch({ type: setErrorMessageType, errorMessage: response.status.toString() });
                        return null;
                    }
                    if (response.url.includes("Security/Login")) {
                        dispatch({ type: loginRequiredType });
                        return null;
                    }
                    return response.json();
                })
                .then(function (json) {
                    if (json !== undefined && json !== null) {
                        if (json.step === done) {
                            window.location.href = "/";
                        } else {
                            cancelSpeechForChangeStep();
                            currentState.step = json.step;
                            dispatch({ type: changeStepType });
                        }
                    }
                })
                .catch(err => {
                    dispatch({ type: setErrorMessageType, errorMessage: err.message });
                });
        })();
    },
    previous: (data) => async (dispatch, getState) => {
        //const body = JSON.stringify({ key: currentState.key, step: currentState.step });
        const body = JSON.stringify({ key: currentState.key, step: currentState.step, data: JSON.stringify(data)});

        (async () => {
            await fetch(`api/AssessmentData/Previous`, {
                    method: "POST",
                    headers: {
                        'Accept': "application/json",
                        'Content-Type': "application/json"
                    },
                    body: body
                })
                .then(function (response) {
                    if (response.status !== 200) {
                        dispatch({ type: setErrorMessageType, errorMessage: response.status.toString() });
                        return null;
                    }
                    if (response.url.includes("Security/Login")) {
                        dispatch({ type: loginRequiredType });
                        return null;
                    }
                    return response.json();
                })
                .then(function (json) {
                    if (json !== undefined && json !== null) {
                        cancelSpeechForChangeStep();
                        currentState.step = json.step;
                        dispatch({ type: changeStepType });
                    }
                })
                .catch(err => {
                    dispatch({ type: setErrorMessageType, errorMessage: err.message });
                });
        })();
    },
    setSpeech: value => async (dispatch, getState) => {
        arrSpeech = value;
        dispatch({ type: hasSpeechType });
        playSpeech(dispatch, false);
    },
    playSpeechForInstructionEnd: value => async (dispatch, getState) => {
        arrSpeech = value.map(str => {
            return { text: str };
        });
        dispatch({ type: hasSpeechType });
        playSpeech(dispatch, true);
    },
    playSpeech: () => async (dispatch, getState) => {
        playSpeech(dispatch, false);
    },
    cancelSpeech: () => async (dispatch, getState) => {
        if (currentState.speechPlaying) {
            try {
                const utterance = window.utteranceRoot;

                if (utterance) {
                    window.utteranceRoot = null;
                    releaseUtterance(utterance);
                }

                window.speechSynthesis.cancel();
            } catch (ex) {
                //
            }

            currentState.speechPlaying = false;
            currentState.speechPlayed = true;

            dispatch({ type: speechEndingType });
        }
    },
    setCurrentTab: value => async (dispatch, getState) => {
        currentState.currentTabId = value;
        dispatch({ type: changeTabType });
    },
    setDevMode: value => async (dispatch, getState) => {
        currentState.devMode = value;
        dispatch({ type: setDevModeType });
    },
    setTrainingMode: value => async (dispatch, getState) => {
        dispatch({ type: setTrainingModeType, trainingMode: value });
    },
    setVolume: value => async (dispatch, getState) => {
        currentState.volume = value;
    },
    unlock: password => async (dispatch, getState) => {
        verifyPassword(dispatch, password, () => dispatch({ type: changeUnlockedType }));
    },
    verifyPassword: (password, func) => async (dispatch, getState) => {
        verifyPassword(dispatch, password, func);
    }
};

function verifyPassword(dispatch, password, func) {
    const body = JSON.stringify({ password: password });

    (async () => {
        await fetch(`api/AssessmentData/VerifyPassword`,
                {
                    method: "POST",
                    headers: {
                        'Accept': "application/json",
                        'Content-Type': "application/json"
                    },
                    body: body
                })
            .then(function (response) {
                if (response.status !== 200) {
                    return null;
                }
                if (response.url.includes("Security/Login")) {
                    dispatch({ type: loginRequiredType });
                    return null;
                }
                return response.json();
            })
            .then(function (json) {
                if (json !== undefined && json !== null) {
                    if (json.success === true) {
                        func();
                    }
                }
            })
            .catch(err => {
                dispatch({ type: setErrorMessageType, errorMessage: err.message });
            });
    })();
}

function releaseUtterance(utterance) {
    utterance.cancelled = true;

    const next = utterance.next;

    if (next) {
        utterance.next = null;
        releaseUtterance(next);
    }
}

function cancelSpeechForChangeStep() {
    try {
        if (currentState.speechPlaying) {
            const utterance = window.utteranceRoot;

            if (utterance) {
                window.utteranceRoot = null;
                releaseUtterance(utterance);
            }

            window.speechSynthesis.cancel();
        }
    } catch (ex) {
        //
    }
    arrSpeech = null;
    currentState.currentTabId = 1;
    currentState.speechPlaying = false;
    currentState.speechPlayed = true;
    currentState.speechPlayedCount = 0;
}

function playSpeech(dispatch, forInstructionEnd) {
    const arr = arrSpeech;

    if (arr === undefined ||
        arr === null ||
        currentState.speechSupported === false ||
        currentState.speechPlaying ||
        (!forInstructionEnd && currentState.speechPlayedCount === 2)) {

        return;
    }

    currentState.currentTabId = 1;
    currentState.speechPlaying = true;

    dispatch({ type: speechBeginningType });

    window.utteranceRoot = null;

    const done = () => {
        currentState.speechPlaying = false;
        currentState.speechPlayed = true;
        if (forInstructionEnd) {
            currentState.speechPlayedCount = 2;
        } else {
            currentState.speechPlayedCount++;
        }
        dispatch({ type: speechEndingType });
    };
    const synth = window.speechSynthesis;
    const tabs = arr.reduce((acc, i) => acc + countTabs(i), 0);

    var last = null;

    if (tabs === 0) {
        let count = arr.length;

        if (currentState.devMode === true) {
            count = Math.min(count, 2);
        }

        loadStrings(synth, null, arr, count, done);
    } else {
        for (let i = 0; i < tabs; i++) {
            const tab = arr[i];

            let count = tab.items.length;

            if (currentState.devMode === true) {
                count = Math.min(count, 2);
            }

            let func;

            if (i < tabs - 1) {
                func = () => {
                    currentState.currentTabId++;
                    dispatch({ type: changeTabType });
                };
            } else {
                func = done;
            }

            last = loadStrings(synth, last, tab.items, count, func);
        }
    }

    setTimeout(function () {
        // delay to ensure page fully rendered and any speech cancellation complete
        if (window.utteranceRoot) {
            synth.speak(window.utteranceRoot);
        }
    }, 500);
}

function countTabs(item) {
    if (item.tabId) return 1;
    return 0;
}

function trimToWord(s) {
    const length = s.length;

    if (length <= 20) {
        return s;
    }

    for (let i = Math.min(20, length) - 1; i > 0; i--) {
        if (s.substring(i, i + 1) === " ") {
            return s.substring(0, i);
        }
    }

    return s;
}

function loadNextString(synth, last, s, func) {
    if (currentState.devMode === true) {
        s = trimToWord(s);
    }

    const utterance = new SpeechSynthesisUtterance(s);

    utterance.cancelled = false;
    utterance.func = func;
    utterance.pitch = 1;
    utterance.rate = currentState.devMode === true ? 2 : 1;
    utterance.volume = currentState.volume;

    if (last) {
        last.next = utterance;
    }

    utterance.onend = function (e) {
        const u = e.utterance;

        if (u.cancelled) {
            return;
        }

        if (u.func) {
            u.func();
        }

        const next = u.next;

        if (next) {
            window.utteranceRoot = next;
            next.volume = currentState.volume;
            synth.speak(next);
        } else {
            window.utteranceRoot = null;
        }
    };

    return utterance;
}

function loadStrings(synth, last, arr, count, func) {
    for (let i = 0; i < count; i++) {
        last = loadNextString(synth, last, arr[i].text, i === count - 1 ? func : null);

        if (window.utteranceRoot === undefined || window.utteranceRoot === null) {
            window.utteranceRoot = last;
        }
    }

    return last;
}

export const reducer = (state, action) => {
    if (currentState.devMode === true) {
        if (action.type === setErrorMessageType) {
            console.log(action.type + ": " + action.errorMessage);
        } else {
            console.log(action.type);
        }
    }

    state = state || currentState;

    if (action.type === getCurrentStepType) {
        return { ...state, step: currentState.step, devMode: currentState.devMode, trainingMode: currentState.devMode, allowDevMode: action.data.allowDevMode, allowTrainingMode: action.data.allowTrainingMode, tests: action.data.tests };
    }

    if (action.type === changeStepType) {
        return { ...state, step: currentState.step, currentTabId: currentState.currentTabId, errorMessage: null, hasSpeech: false, speechPlaying: currentState.speechPlaying, speechPlayed: currentState.speechPlayed, speechPlayedCount: currentState.speechPlayedCount };
    }

    if (action.type === hasSpeechType) {
        return { ...state, hasSpeech: true };
    }

    if (action.type === speechBeginningType) {
        return { ...state, currentTabId: currentState.currentTabId, speechPlaying: currentState.speechPlaying };
    }

    if (action.type === changeTabType) {
        return { ...state, currentTabId: currentState.currentTabId };
    }

    if (action.type === speechEndingType) {
        return { ...state, speechPlaying: currentState.speechPlaying, speechPlayed: currentState.speechPlayed, speechPlayedCount: currentState.speechPlayedCount };
    }

    if (action.type === setErrorMessageType) {
        return { ...state, errorMessage: action.errorMessage };
    }

    if (action.type === setDevModeType) {
        return { ...state, devMode: currentState.devMode };
    }

    if (action.type === setTrainingModeType) {
        return { ...state, trainingMode: action.trainingMode };
    }

    if (action.type === changeUnlockedType) {
        return { ...state, unlocked: true };
    }

    if (action.type === loginRequiredType) {
        return { ...state, loginRequired: true };
    }

    return state;
};
